import { render, staticRenderFns } from "./PxCamposCompraItemLm.vue?vue&type=template&id=3a0be63c&"
import script from "./PxCamposCompraItemLm.vue?vue&type=script&lang=js&"
export * from "./PxCamposCompraItemLm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports